import React, { useReducer } from 'react';
import { ls } from "../../../locale"

import { FormControl, FormGroup } from 'react-bootstrap'
import FormErrorBlock from '../../../components/FormErrorBlock'


import { reducer, isEmptyErrors } from '../Signin/reducer';
import { initialState, validateValues } from './resetFormData';

type FormProps = {
  email: string,
  onSubmit: (data: {
    password: string,
  }) => void
}

export function ResetPasswordForm({ email, onSubmit }: FormProps) {

  const [state, dispatch] = useReducer(reducer, initialState)

  const rInput = ls.t('Input')

  const setErrors = (errors: any) => {
    dispatch({
      type: 'errors',
      payload: errors
    })
  }

  const setValue = (key: string, value: string) => {
    dispatch({
      type: 'value',
      payload: { key, value}
    })
  }

  const handleSubmit = (form: any) => {
    form.preventDefault();
  
    const values = state.values;
    const errors = validateValues(values)
    if(isEmptyErrors(errors)) {
      setErrors(errors)
      return
    }

    onSubmit({
      password: values.password,
    })
  }

  const {values, errors } = state;

  return (
    <div className="form-content">
      <div className="tw-mb-5">Reset password for <span className="tw-font-bold">{email}.</span></div>

      <form onSubmit={handleSubmit}>
        <FormGroup className={errors.password ? "has-error" : null}>
          <FormControl type="password"
            placeholder={rInput.Password + " *"}
            value={values.password}
            onChange={(event: any) => setValue('password', event.target.value)} />
          <FormErrorBlock error={errors.password} />
        </FormGroup>

        <FormGroup className={errors.confirmPassword ? "has-error" : null}>
          <FormControl type="password"
            placeholder={rInput.ConfirmPassword + " *"}
            value={values.confirmPassword}
            onChange={(event: any) => setValue('confirmPassword', event.target.value)} />
          <FormErrorBlock error={errors.confirmPassword} />
        </FormGroup>

        <div className="actions">
          <button type="submit">Reset Password</button>
        </div>

      </form>
    </div>
  )
}
